import React from 'react';

export default function EnvelopeSvg ({color = '#FFF'}){
    return (
    <svg width="100%" height="100%" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="8" y="16" width="48" height="32" rx="2" stroke={color} strokeWidth="2"/>
        <path d="M9.25293 17.1722L30.7241 33.6679C31.4409 34.2185 32.4378 34.22 33.1562 33.6716L54.769 17.1722" stroke={color} strokeWidth="2"/>
    </svg>
)
}